import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalendarRangeControlComponent } from './calendar-range-control.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [CalendarRangeControlComponent],
  exports: [CalendarRangeControlComponent],
  imports: [
    CommonModule,
    BsDatepickerModule,
    ReactiveFormsModule,
  ],
})
export class CalendarRangeControlModule {}
